import { render, staticRenderFns } from "./FilterUserFirstInteract.vue?vue&type=template&id=127f4d2c"
import script from "./FilterUserFirstInteract.vue?vue&type=script&lang=js"
export * from "./FilterUserFirstInteract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('127f4d2c')) {
      api.createRecord('127f4d2c', component.options)
    } else {
      api.reload('127f4d2c', component.options)
    }
    module.hot.accept("./FilterUserFirstInteract.vue?vue&type=template&id=127f4d2c", function () {
      api.rerender('127f4d2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Segment/Components/FilterUserFirstInteract.vue"
export default component.exports